import { useInvestmentInfo } from './hooks';
import { InvestmentInfoTemplate } from 'views/components/templates/establishes';
import { Gauge, GaugeSP, getGaugeValue } from 'views/components/atoms/gauge';
import { useLocation } from 'react-router-dom';

export const InvestmentInfo = () => {
  const tempProps = useInvestmentInfo();
  const location = useLocation();

  return (
    <form className="establishFormSP" onSubmit={tempProps.formik.handleSubmit}>
      <GaugeSP currentPage={getGaugeValue(location.pathname)} />
      <InvestmentInfoTemplate {...tempProps} />
    </form>
  );
};
